import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-upload', 'upload', 'Įkelti');
Labels.set('ui-upload', 'uploadFiles', 'Įkelti failus');
Labels.set('ui-upload', 'clear', 'Pašalinti failą');
